export default __webpack_public_path__ + "static/media/gallery-image-12-full.f430aeed.jpg";